import { gql } from '@apollo/client';

export default gql`
  query stations {
    stations {
      uic
      shortCode
      name
      priority
      isRdg
      isEurostarDirect
      city
      countryCode
      searchStrings @client
    }
  }
`;
